import { i } from '@/utils/desc'

export default [
  {
    number: 1,
    title: 'Absorb',
    text: "We'll start by listening to your story — learning about your lifestyle, your design concerns, the most precious of your possessions and the most important people in your life who will live in your home. We believe that the information that we gather from your current space is as important as learning about your dreams for the new one.",
    // props
    titlePos: 'right',
    titleClass: 'text-xs-center text-sm-left text-md-right',
    textClass: 'text-xs-center text-sm-left text-md-right'
  },
  {
    number: 2,
    title: 'Envision',
    text: `We'll invite you ${i("IdeaForma's")} creative playground where we'll play with colors and toss around ideas until a design vision is created. This part of the process gives you a sneak peek of the end in mind. It's a presentation of the big picture yet full of all those little details, all about your future home.`,
    // props
    titlePos: 'right',
    titleClass: 'text-xs-center text-sm-left text-md-right',
    textClass: 'text-xs-center text-sm-left text-md-right'
  },
  {
    number: 3,
    title: 'Collaborate',
    text: "We're all about working hand in hand with our clients in coming up with collaborative ideas and finding design solutions together —  from big decisions in furniture space planning to the littlest of details like organizing your closet shelves & drawers. It's putting together your needs & wants with our ideas & expertise in the most collaborative experience.",
    // props
    titlePos: 'right',
    titleClass: 'text-xs-center text-sm-left text-md-right',
    textClass: 'text-xs-center text-sm-left text-md-right'
  },
  {
    number: 4,
    title: 'Aim',
    text: 'Considering both budget and timeline, we set clear-cut goals. We pride ourselves with the most efficient monitoring and project management experience in interior design & construction making the experience as delightful as possible.',
    // props
    titlePos: 'left',
    titleClass: 'text-xs-center text-sm-left text-md-left',
    textClass: 'text-xs-center text-sm-left text-md-left'
  },
  {
    number: 5,
    title: 'Build',
    text: 'Turning the vision to reality, we start building the space. As the one of the most critical phases in the process, we will keep you updated on all the accomplishments and promise the most creative solutions in times that bridging the vision and reality may become a challenge.',
    // props
    titlePos: 'left',
    titleClass: 'text-xs-center text-sm-left text-md-left',
    textClass: 'text-xs-center text-sm-left text-md-left'
  },
  {
    number: 6,
    title: 'Live',
    text: "We deliver as close to the design perspectives. We clean each nook & cranny. We help you prepare the space for living. After achieving our design & project goals and finishing your new home, it's time to enjoy, it's time to live.",
    // props
    titlePos: 'left',
    titleClass: 'text-xs-center text-sm-left text-md-left',
    textClass: 'text-xs-center text-sm-left text-md-left'
  }
]
